import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";
import DeleteIcon from "@mui/icons-material/Delete";

const DeleteTrainingBaseDialog = ({ fetchAssignedTrainingBases, studentEducationId, trainingBaseId }) => {
  const notify = useNotify();

  const handleDelete = async () => {
    await dataProvider.customRequest(
      graduationRequests.deleteStudentTrainingBase(studentEducationId, trainingBaseId),
      null,
      "DELETE",
    );
    fetchAssignedTrainingBases();
    notify("Успешно изтриване на учебна база", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={handleDelete}
      titleContent={"Изтриване на учебна база"}
      triggerButton={
        <Button
          label="Изтрий"
          startIcon={<DeleteIcon />}
          color="error"
        />
      }
      message="Сигурни ли сте, че искате да изтриете учебната база?"
    />
  );
};

export default DeleteTrainingBaseDialog;
